import { usePromo } from '../context/PromoContext'
import './MobileNav.css'

function MobileNav() {
  const { partnerLogo, partnerWebsite } = usePromo()
  const partnerUrl = partnerWebsite?.startsWith('http') ? partnerWebsite : `https://${partnerWebsite}`

  return (
    <div className="claimform-mobile-nav">
      <div className="claimform-logo-group">
        <a href="https://passengersfriend.com" className="claimform-logo">
          <img src="/images/logos/pf_logo.svg" alt="Passengers friend" width="800" height="264" />
        </a>
        {partnerLogo && (partnerWebsite ? (
          <a href={partnerUrl} className="claimform-partner-logo" target="_blank" rel="noopener noreferrer">
            <img src={partnerLogo} alt="Partner" />
          </a>
        ) : (
          <div className="claimform-partner-logo">
            <img src={partnerLogo} alt="Partner" />
          </div>
        ))}
      </div>
      <div className="g-badge">
      </div>
    </div>
  )
}

export default MobileNav
